import React from 'react';
import {IconFile} from "../Icons/IconFile";

export const Attachment = ({link, name}) => {

    return(<a target="_blank" href={link} className="chat-attach-item">
        {link.match(/\.(jpeg|jpg|gif|png)$/) != null ?
            <div className="chat-attach-item-img" style={{backgroundImage: 'url('+link+')'}}/>
            : <div><IconFile style={{color: 'rgb(0, 140, 255)'}}/></div>
        }
        <div className="chat-attach-item-text" style={{marginLeft: 8}}>
            {name}
        </div>
    </a>)
}